import { Button, CircularProgress, TableRow, TableHead, Table, TableCell, TableBody, TableContainer, Dialog, DialogContent } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { queryClient } from 'queryClient';
import { useState } from 'react';
import PageTitle from 'components/PageTitle/PageTitle';
import plansSAService from 'services/superadmin/plansSAService';
import { PlanForm } from './components/PlanForm';
import { toast } from 'react-toastify';

export const PlanList = () => {
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['plans'],
        queryFn: async () => {
            const { data } = await plansSAService.getAll();
            return data;
        },
        refetchOnWindowFocus: false,
    });

    const [plan, setPlan] = useState<any>(null);
    const [isOpenPlanForm, setIsOpenPlanForm] = useState(false);

    const handleAddPlan = () => {
        setIsOpenPlanForm(true);
    }

    const onDelete = async (u: any) => {
        if (window.confirm('Вы уверены, что хотите удалить тариф?')) {
            try {
                await plansSAService.delete(u.id);
                toast.success('Тариф успешно удален!');

                queryClient.setQueryData(['plans'], (old: any) => {
                    return old.filter((item: any) => item.id !== u.id);
                });
            } catch (error) {
                console.log(error);
                toast.error('Ошибка при удалении тарифа!');
            }
        }
    };

    const handleEditPlan = async (v: any) => {
        console.log("v: ", v);
        setPlan(v);
        setIsOpenPlanForm(true);
    }

    const onSubmit = async (data: any) => {
        console.log("data: ", data);
        try {
            if (plan?.id) {
                await plansSAService.update(plan.id, data);
                toast.success('Тариф успешно обновлен!');
            } else {
                await plansSAService.create(data);
                toast.success('Тариф успешно создан!');
            }
            refetch();
        } catch (error) {
            console.log(error);
            toast.error('Ошибка при сохранении тарифа!');
        } finally {
            setIsOpenPlanForm(false);
            setPlan(null);
        }
    }

    const handleClosePlanForm = () => {
        setIsOpenPlanForm(false);
        setPlan(null);
    }

    if (isLoading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <PageTitle>Список тарифов</PageTitle>
                <Button variant="contained" color="primary" onClick={handleAddPlan}>Добавить тариф</Button>
            </div>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Название</TableCell>
                            <TableCell>Статус</TableCell>
                            <TableCell>Цена</TableCell>
                            <TableCell>Валюта</TableCell>
                            <TableCell>Период оплаты</TableCell>
                            <TableCell>Количество дней пробного периода</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((item: any) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <TableCell>{item.name}</TableCell>
                                <TableCell>{item.isActive ? 'Активный' : 'Неактивный'}</TableCell>
                                <TableCell>{item.price}</TableCell>
                                <TableCell>{item.currency}</TableCell>
                                <TableCell>{item.billingPeriod}</TableCell>
                                <TableCell>{item.trialDays}</TableCell>
                                <TableCell>
                                    <Button variant="outlined" color="info" onClick={() => handleEditPlan(item)}>Редактировать</Button>
                                </TableCell>
                                <TableCell>
                                    <Button variant="outlined" color="error" onClick={() => onDelete(item)}>Удалить</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog
                fullWidth
                maxWidth="lg"
                open={isOpenPlanForm}
                onClose={handleClosePlanForm}
            >
                <DialogContent>
                    <PlanForm plan={plan} onSubmit={onSubmit} />
                </DialogContent>
            </Dialog>
        </div>
    );
}
